import { render, staticRenderFns } from "./BankStatementDropZone.vue?vue&type=template&id=54bfff7e&scoped=true&"
import script from "./BankStatementDropZone.vue?vue&type=script&lang=js&"
export * from "./BankStatementDropZone.vue?vue&type=script&lang=js&"
import style0 from "./BankStatementDropZone.vue?vue&type=style&index=0&id=54bfff7e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bfff7e",
  null
  
)

export default component.exports